export var HarmonyErrorSource;
(function (HarmonyErrorSource) {
    /**
     * Indicates that the error occurred in the Connect Service client.
     */
    HarmonyErrorSource["CONNECT_API"] = "connect-api";
    /**
     * Indicates that the error occurred inside Harmony's orchestrator.
     */
    HarmonyErrorSource["HARMONY"] = "harmony";
    /**
     * Indicates that the error occurred in the Playback module.
     */
    HarmonyErrorSource["PLAYBACK"] = "playback";
    /**
     * Indicates that the error occurred in the Track Playback client.
     */
    HarmonyErrorSource["TRACK_PLAYBACK"] = "track-playback";
    /**
     * Indicates that the error occurred in the Transport module.
     */
    HarmonyErrorSource["TRANSPORT"] = "transport";
})(HarmonyErrorSource || (HarmonyErrorSource = {}));
//# sourceMappingURL=error_source.js.map